/**
 * Languages.
 * @module constants/Languages
 */

module.exports = {
  ca: 'Català',
  de: 'Deutsch',
  en: 'English',
  es: 'Español',
  eu: 'Euskara',
  fi: 'Suomi',
  fr: 'Français',
  it: 'Italiano',
  nl: 'Nederlands',
  ro: 'Română',
  ja: '日本語',
  pt: 'Português',
  pt_BR: 'Português (Brasil)',
  zh_CN: '中文',
};
